define('home/activityExpander',[
    'underscore',

    'core/UniqueModel',
    'core/utils/objectExpander',

    'home/models/User',
    'home/models/Post',
    'home/models/Thread',
    'home/models/Forum',
    'home/models/Channel',
    'home/models/Announcement',
], function (
    _,

    UniqueModel,
    objectExpander,

    User,
    Post,
    Thread,
    Forum,
    Channel,
    Announcement
) {
    'use strict';

    /**
     * See core/objectExpander for docs.
     */
    return _.extend(objectExpander, {
        // Overwrite local reference to model(s) so that builders inherited from
        // core's objectExpander will build project-sprecific models
        Channel: Channel,
        Thread: Thread,

        /**
         * Creates and returns a new unique post model.
         * Looks up and passes the appropriate thread, author, and forum attributes
         * to the post constructor so it doesn't need a separate fetch call to
         * populate those models.
         *
         * @param  {Object} objects - Mapping of model type/id to model attributes
         * @param  {object/string} postAttrs - either the post attributes or the
         *                                     type/id string to lookup the attributes
         *                                     in the objects mapping
         *
         * @returns {Post}           - A Post UniqueModel with a User model set as the
         *                            author and a Thread model set as the thread
         */
        buildPost: function (objects, postAttrs) {
            if (postAttrs instanceof Post)
                return postAttrs;

            postAttrs = this.parseObject(objects, postAttrs);

            var threadAttrs = this.parseObject(objects, postAttrs.thread) ||
                // TODO remove this hack
                // This is here because the endpoint currently doesn't return the thread
                // of a parent post in the same way as with activity level posts.
                // Parent posts have just the thread id, and that thread may not be in
                // the objects mapping.
                // First try to look up the thread attrs in the objects mapping, it may
                // be there.
                // If it's not, look up the unique thread model that should already exist,
                // since it would have been created for the reply post before the parent
                // post is created.
                objects['forums.Thread?id=' + postAttrs.thread] ||
                UniqueModel.pool(Thread)[postAttrs.thread];

            return new UniqueModel(
                Post,
                postAttrs,
                {
                    author: this.parseObject(objects, postAttrs.author),
                    thread: this.buildThread(objects, threadAttrs),
                }
            );
        },

        buildAnnouncement: function (objects, announcementAttrs) {
            return new Announcement(this.parseObject(objects, announcementAttrs));
        },

        /**
         * Creates and returns a new unique user model.
         *
         * @param  {Object} objects  - Mapping of model type/id to model attributes
         * @param  {string} userAttrs - either the user attributes or the type/id
         *                                string to lookup the user attributes
         *
         * @returns {User}          - A User UniqueModel
         */
        buildUser: function (objects, userAttrs) {
            if (userAttrs instanceof User)
                return userAttrs;

            userAttrs = this.parseObject(objects, userAttrs);

            return new UniqueModel(
                User,
                userAttrs
            );
        },

        buildForum: function (objects, forumAttrs) {
            if (forumAttrs instanceof Forum)
                return forumAttrs;

            forumAttrs = this.parseObject(objects, forumAttrs);

            return new UniqueModel(
                Forum,
                forumAttrs
            );
        },
    });
});

